export default __webpack_public_path__ + "static/cs-logo-footer-e068cd53557fc18f92c5045b847ff6ad.png";